import React from "react";

/**
 * "Close without saving?" guard for the asset editors (form / survey, swipe
 * deck, quiz). The editors deliberately don't close on backdrop click or
 * Escape, but the X sits right next to Create / Save and an accidental click
 * used to throw away everything. Styled like SwipeDecksDisplay's DeleteConfirm.
 *
 * `isNew`: the asset has never been saved, so closing deletes it outright
 * (vs. discarding edits to something that still exists).
 */
function DiscardChangesConfirm({ noun, isNew, onKeepEditing, onDiscard }) {
  return (
    <div
      className="fixed inset-0 z-[1500] bg-black/50 flex items-center justify-center px-4"
      onClick={onKeepEditing}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-slate-900 mb-2">
          {isNew ? `Discard this ${noun}?` : "Close without saving?"}
        </h3>
        <p className="text-sm text-slate-500 mb-6">
          {isNew
            ? `This ${noun} hasn't been created yet. Closing now throws away everything you've added.`
            : `You have unsaved changes to this ${noun}. Closing now loses them.`}
        </p>
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onKeepEditing}
            className="px-4 py-2 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
            autoFocus
          >
            Keep editing
          </button>
          <button
            type="button"
            onClick={onDiscard}
            className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"
          >
            {isNew ? "Discard" : "Close without saving"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DiscardChangesConfirm;
